import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getBuyerQuotes = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerQuotesData - error", error)
        return handleApiError(error)
    }
}

export const sendBuyerQuotation = async (buyerId) => {
    try {
        let data = {}
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/send-buyer-quot/${buyerId}`, data);
        return await response.data;
    } catch (error) {
        console.log("sendBuyerQuotation - error", error)
        return handleApiError(error)
    }
}

export const addBuyerQuote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/add-buyer-quote`, data);
        return await response.data;
    } catch (error) {
        console.log("buyer quote - error", error)
        return handleApiError(error)
    }
}

export const getBuyerQuoteByBuyerQuoteId = async (buyerQuoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-quote/get-buyer-quote/${buyerQuoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerQuoteByBuyerQuoteId - error", error)
        return handleApiError(error)
    }
}

export const getBuyerQuotesByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/all-buyer-quote`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerQuotesByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const cancelBuyerQuote = async (buyerQuoteId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/cancel/${buyerQuoteId}`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelBuyerQuote - error", error)
        return handleApiError(error)
    }
}

export const updateBuyerQuote = async (buyerQuoteId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/update/${buyerQuoteId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateBuyerQuote - error", error)
        return handleApiError(error)
    }
}

export const getPrevBuyerQuotesForMaterial = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/prev-quotes`, data);
        return await response.data;
    } catch (error) {
        console.log("getPrevTransactionsForMaterial - error", error)
        return handleApiError(error)
    }
}

export const getBuyerQuoteByDocNo = async (buyerQuoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-quote/get-buyer-quote-by-doc-no/${buyerQuoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerQuoteByDocNo - error", error)
        return handleApiError(error)
    }
}

export const getBuyerQuoteWithNoPO = async (userId, companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-quote/get-buyer-quote-with-no-po/${userId}?companyId=${companyId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerQuoteWithNoPO - error", error)
        return handleApiError(error)
    }
}

export const getBuyerQuoteClosureReasonList = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-quote/all-closure-reason`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerQuoteClosureReasonList - error", error)
        return handleApiError(error)
    }
}